import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  isLoading: boolean;

  constructor(public loadingController: LoadingController) {
    this.isLoading = false;
  }

  async presentLoading(message: string, cssClass?: string) {
    const loading = await this.loadingController.create({
      cssClass: cssClass || 'my-custom-class',
      message: message
    });
    this.isLoading = true;
    await loading.present();

    const { role, data } = await loading.onDidDismiss();
  }

  async presentLoadingWithOptions(spinner: any, duration: number, message: string, translucent?: boolean, cssClass?: string, backdropDismiss?: boolean) {
    const loading = await this.loadingController.create({
      spinner: spinner,
      duration: duration,
      message: message,
      translucent: (translucent != null ? translucent  : true),
      cssClass: cssClass || 'custom-class custom-loading',
      backdropDismiss: backdropDismiss || false
    });
    this.isLoading = true;
    await loading.present();

    await loading.onDidDismiss().then(() => {
      // Clear isLoading just in case time out occurs before dismiss is called
      this.isLoading = false;
    });
  }

  dismiss() {
    if(this.isLoading) {
      this.loadingController.dismiss().then(() => {
        this.isLoading = false;
      });
    }
  }
}
